import React from 'react';

import './desktop-ranking-style.scss';
import DesktopAppDownload from '@src/componentsNew/AppDownload/DesktopAppDownload';

const DesktopRankingPage = ({ deepLink }) => {
  return (
    <div id="desktop-ranking-wrapper">
      <DesktopAppDownload
        deepLink={deepLink}
        infoText={`Discover best seller of K-beauty products\non the Maccaron App`}
      />
    </div>
  );
};

export default DesktopRankingPage;
